import { ActionIcon, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconLiveView } from "@tabler/icons-react";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { Map, MapMarker, MapTypeId, Roadview } from "react-kakao-maps-sdk";

export default function OrderDetailStreetViewModal({ lat, lng, id }) {
  if (!lat || !lng) return null;

  const kakao = window?.kakao;

  const [opened, { open, close }] = useDisclosure(false);
  const [center, setCenter] = useState({
    lat: lat,
    lng: lng,
  });

  return (
    <>
      <ActionIcon size="sm" variant="default" onClick={open} disabled={!lat || !lng}>
        <IconLiveView size={16} />
      </ActionIcon>

      <Modal opened={opened} onClose={close} title="로드뷰" size="xl" zIndex={10000} p={0}>
        <Roadview // 로드뷰를 표시할 Container
          position={{
            // 지도의 중심좌표
            lat: center.lat,
            lng: center.lng,
            radius: 100,
          }}
          zoom={-3}
          style={{
            // 지도의 크기
            width: "100%",
            height: "35dvh",
            borderRadius: "8px",
          }}
        />
        <Map // 로드뷰를 표시할 Container
          center={{
            lat: lat,
            lng: lng,
          }}
          style={{
            width: "100%",
            height: "35dvh",
            borderRadius: "8px",
          }}
          level={3}
        >
          <MapTypeId type={kakao?.maps?.MapTypeId?.ROADVIEW} />
          <MapMarker
            position={{
              lat: center.lat,
              lng: center.lng,
            }}
            draggable={true}
            onDragEnd={(marker) => {
              setCenter({
                lat: marker.getPosition().getLat(),
                lng: marker.getPosition().getLng(),
              });
            }}
            image={{
              src: "https://t1.daumcdn.net/localimg/localimages/07/2018/pc/roadview_minimap_wk_2018.png",
              size: { width: 26, height: 46 },
              options: {
                spriteSize: { width: 1666, height: 168 },
                spriteOrigin: { x: 705, y: 114 },
                offset: { x: 13, y: 46 },
              },
            }}
          />
        </Map>
      </Modal>
    </>
  );
}
